(() => {
  'use strict';
  const viewport = window.matchMedia('(max-width: 767px)');
  const labelsElement = document.getElementById('SecondgearUxText');
  const labels = labelsElement ? JSON.parse(labelsElement.textContent) : {};
  let open = false;
  let activePanel;
  let activeDialog;
  let returnFocus;
  let lastFilterLabel = '';
  let previousFocusId = '';
  let expandedGroups = new Map();
  const countLabel = (count) => String(labels.showResults || '__COUNT__').replace('__COUNT__', String(count));
  const isSameStoreUrl = (url) => new URL(url, window.location.href).origin === window.location.origin;
  const groupKey = (details) => details.querySelector('summary')?.getAttribute('aria-controls');
  const beforeListingUpdate = () => {
    previousFocusId = document.activeElement?.id || '';
    if (!open || !activePanel) return;
    expandedGroups = new Map(Array.from(activePanel.querySelectorAll('.open-container-filter > details')).map((details) => [groupKey(details), details.open]));
  };
  const close = () => {
    if (activeDialog?.open) activeDialog.close();
    const details = document.querySelector('#sorting > details');
    if (details) details.open = false;
    open = false;
    document.body.classList.remove('secondgear-filter-open');
    if (returnFocus?.isConnected) returnFocus.focus();
  };
  const ensureDialog = (panel) => {
    let dialog = panel.querySelector(':scope > .secondgear-filter-dialog');
    if (!viewport.matches) {
      if (dialog) {
        if (dialog.open) dialog.close();
        const filters = dialog.querySelector(':scope > .collection-filters');
        if (filters) panel.append(filters);
        dialog.remove();
      }
      activeDialog = undefined;
      return;
    }
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'secondgear-filter-dialog';
      dialog.id = 'SecondgearFilterDialog';
      dialog.setAttribute('aria-labelledby', 'SecondgearFilterHeading');
      const heading = document.createElement('div');
      heading.className = 'secondgear-filter-heading';
      const title = document.createElement('strong');
      title.id = 'SecondgearFilterHeading';
      title.textContent = labels.filterTitle || '';
      const closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.textContent = labels.close || '';
      closeButton.addEventListener('click', close);
      heading.append(title, closeButton);
      Array.from(panel.childNodes).forEach((node) => dialog.append(node));
      dialog.prepend(heading);
      const footer = document.createElement('div');
      footer.className = 'secondgear-filter-footer';
      const showButton = document.createElement('button');
      showButton.type = 'button';
      showButton.className = 'btn secondgear-filter-show';
      showButton.addEventListener('click', close);
      footer.append(showButton);
      dialog.append(footer);
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      });
      panel.append(dialog);
    }
    activeDialog = dialog;
    return dialog;
  };
  const stockScopeLabel = (values, data) => {
    if (values.some(value => value !== '0' && value !== '1')) return '';
    const active = new Set(values);
    if (active.has('1') && active.has('0')) return data.stockAll;
    if (active.has('1')) return data.stockIn;
    if (active.has('0')) return data.stockSold;
    return data.stockNone;
  };
  const updateEmptyStockScope = () => {
    const values = new URL(window.location.href).searchParams.getAll('filter.v.availability');
    document.querySelectorAll('[data-secondgear-stock-scope]').forEach(node => {
      const text = stockScopeLabel(values, node.dataset) || '';
      if (node.textContent !== text) node.textContent = text;
    });
  };
  const synchronize = () => {
    updateEmptyStockScope();
    const sorting = document.getElementById('sorting');
    const details = sorting?.querySelector(':scope > details');
    const panel = sorting?.querySelector(':scope > .collection-template-filters');
    if (!details || !panel) {
      const wasOpen = open;
      close();
      activePanel = undefined;
      activeDialog = undefined;
      if (wasOpen) {
        const state = document.querySelector('[data-secondgear-listing-state]');
        state?.setAttribute('tabindex', '-1');
        state?.focus({ preventScroll: true });
      }
      return;
    }
    const summary = details.querySelector('summary');
    activePanel = panel;
    const dialog = ensureDialog(panel);
    if (details.dataset.secondgearFilterReady !== 'true') {
      details.dataset.secondgearFilterReady = 'true';
      details.addEventListener('toggle', () => {
        if (!viewport.matches) return;
        if (details.open) {
          open = true;
          returnFocus = summary;
          const currentDialog = ensureDialog(panel);
          if (currentDialog && !currentDialog.open) currentDialog.showModal();
          document.body.classList.add('secondgear-filter-open');
        } else close();
        summary?.setAttribute('aria-expanded', String(open));
      });
      if (viewport.matches && !open) details.open = false;
    }
    const count = document.querySelector('[data-secondgear-listing-state]')?.dataset.resultCount;
    const showButton = dialog?.querySelector('.secondgear-filter-show');
    if (showButton) showButton.textContent = countLabel(count || '0');
    if (open && viewport.matches && dialog) {
      returnFocus = summary;
      if (!dialog.open) dialog.showModal();
    }
  };
  const initialize = () => {
    synchronize();
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('.advanced-filter a') : null;
      if (target && open) lastFilterLabel = target.textContent.trim();
    }, true);
    document.addEventListener('secondgear:listing-updated', () => {
      synchronize();
      if (!open || !activePanel) {
        const previousFocus = previousFocusId ? document.getElementById(previousFocusId) : null;
        previousFocus?.focus({ preventScroll: true });
        return;
      }
      activePanel.querySelectorAll('.open-container-filter > details').forEach((details) => {
        const key = groupKey(details);
        if (expandedGroups.has(key)) details.open = expandedGroups.get(key);
      });
      const previousFocus = previousFocusId ? document.getElementById(previousFocusId) : null;
      const link = lastFilterLabel ? Array.from(activePanel.querySelectorAll('.advanced-filter a')).find((node) => node.textContent.trim() === lastFilterLabel) : null;
      const target = previousFocus || link || activeDialog?.querySelector('button');
      if (target && window.getComputedStyle(target).visibility !== 'hidden') target.focus();
    });
    document.addEventListener('shopify:section:load', synchronize);
    viewport.addEventListener('change', () => {
      close();
      const details = document.querySelector('#sorting > details');
      if (details && !viewport.matches) details.open = true;
      synchronize();
    });
    window.addEventListener('pageshow', synchronize);
  };
  window.SecondgearUx = { filterIsOpen: () => open && viewport.matches, beforeListingUpdate, synchronize, isSameStoreUrl, countLabel };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();

// Close the native header menu through its existing toggle, preserving animation.
(() => {
  window.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || event.defaultPrevented || document.querySelector('dialog[open]')) return;
    const trigger = document.querySelector('#header.secondgear-compact-header .toggleMenu');
    if (trigger?.parentElement?.getAttribute('aria-expanded') !== 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    trigger.click();
    trigger.focus({ preventScroll: true });
  }, true);
})();
